import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { AlumnoManager } from './utils/useAlumno'
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import theme from './hoc/theme'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <>
      <CssBaseline />
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <AlumnoManager>
              <App />
            </AlumnoManager>
          </ThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </>
  </React.StrictMode>
)